// The domain is set per-branch via .env.production / .env.development
// (see those files' comments) - production is the safe fallback if the
// variable is ever missing, so a misconfigured build defaults to the
// correct backend rather than silently pointing at staging.
const API_DOMAIN = process.env.REACT_APP_API_DOMAIN || "api.firmconnector.com";

const API_BASE         = `https://${API_DOMAIN}/index.php/`;
const ASSETS_BASE      = `https://${API_DOMAIN}/assets/`;
const PROFILE_IMG_BASE = `https://${API_DOMAIN}/`;
const FIRM_IMG_BASE    = `https://${API_DOMAIN}/`;

export { API_BASE, ASSETS_BASE, PROFILE_IMG_BASE, FIRM_IMG_BASE };
